import React, { useState, useEffect } from "react";
import DeleteCategory from "./DeleteCategory";
import { isAuthenticated } from "../../auth";

const Category = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/category`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setData(data), setLoading(false);
      });
  }, [props]);

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow spinner-grow-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  return (
    <div>
      <div className="card-header">
        <h2>
          {" "}
          <img
            src="https://img.icons8.com/material-sharp/24/000000/place-marker.png"
            alt="icon"
          />{" "}
          List of Area
        </h2>
        {showloading()}
        <ul className="list-group list-group-flush">
          {data
            .map((category) => {
              return (
                <li key={category._id} className="list-group-item">
                  <img
                    src="https://img.icons8.com/metro/15/000000/entering-geo-fence.png"
                    alt="icon"
                  />
                  {"  "}

                  {category.name}
                  {isAuthenticated().user.role === 1 && (
                    <DeleteCategory categoryId={category._id} />
                  )}
                </li>
              );
            })

            .reverse()}
        </ul>
      </div>
    </div>
  );
};

export default Category;
